module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Media-folder-38d842fe7c64396a7cb05cda984e3bd0.svg";